
import { useContext } from 'react';
import ChatBotContext from '../contexts/ChatBotContext';

const useChatBot = () => useContext(ChatBotContext);

export default useChatBot;